import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';

import Form from './Form';
import { useStepper } from './Stepper/StepperProvider';

const SuccessMessage = dynamic(() => import('./SuccessMessage'), {
  ssr: false,
});

const Body = ({
  gaEventCategory,
  showSuccessMessage,
  suggestedOfferId = null,
  onSubmitSuccess,
  onSuggestAnotherOfferClick,
}) => {
  const { changeActiveStep } = useStepper();

  const onSuggestAnotherOfferClickHandler = () => {
    changeActiveStep({ type: 'reset' });
    onSuggestAnotherOfferClick();
  };

  return (
    <Box className="mb-12 md:mb-18">
      {!showSuccessMessage && (
        <Form
          gaEventCategory={gaEventCategory}
          onSubmitSuccess={onSubmitSuccess}
        />
      )}
      {showSuccessMessage && (
        <SuccessMessage
          gaEventCategory={gaEventCategory}
          offerId={suggestedOfferId}
          onSuggestAnotherOfferClick={onSuggestAnotherOfferClickHandler}
        />
      )}
    </Box>
  );
};

Body.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  showSuccessMessage: PropTypes.bool.isRequired,
  suggestedOfferId: PropTypes.number,
  onSubmitSuccess: PropTypes.func.isRequired,
  onSuggestAnotherOfferClick: PropTypes.func.isRequired,
};

export default Body;
